module.exports = __webpack_public_path__ + "img/7F8896_3B3936_BBCFE9_4B4B4D-256px.ad9ff6a8.png";